// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1spDv","buttons":"RemoveExpirationActionButtons_buttons__3yb68"};